module.exports = __webpack_public_path__ + "static/mobilediagram-557cf4ce178e186fde685e14d0ea9d0a.jpg";